const ArtistIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 10C9.95963 10 10.4148 9.90947 10.8394 9.73358C11.264 9.55769 11.6499 9.29988 11.9749 8.97487C12.2999 8.64987 12.5577 8.26403 12.7336 7.83939C12.9095 7.41475 13 6.95963 13 6.5C13 6.04037 12.9095 5.58525 12.7336 5.16061C12.5577 4.73597 12.2999 4.35013 11.9749 4.02513C11.6499 3.70012 11.264 3.44231 10.8394 3.26642C10.4148 3.09053 9.95963 3 9.5 3C8.57174 3 7.6815 3.36875 7.02513 4.02513C6.36875 4.6815 6 5.57174 6 6.5C6 7.42826 6.36875 8.3185 7.02513 8.97487C7.6815 9.63125 8.57174 10 9.5 10Z"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 14H9.4C7.16 14 6.04 14 5.184 14.436C4.43139 14.8195 3.81949 15.4314 3.436 16.184C3 17.04 3 18.16 3 20.4V21H13.5M20 20.5L18.414 18.9145M18.414 18.9145C18.6 18.729 18.7476 18.5081 18.8481 18.2655C18.9487 18.0228 19.0003 17.7627 19 17.5C19.0001 17.0373 18.8398 16.5888 18.5463 16.2311C18.2528 15.8734 17.8444 15.6284 17.3906 15.5381C16.9368 15.4477 16.4657 15.5175 16.0575 15.7356C15.6494 15.9536 15.3295 16.3064 15.1524 16.7339C14.9752 17.1613 14.9518 17.637 15.086 18.0798C15.2203 18.5226 15.5039 18.9052 15.8886 19.1623C16.2733 19.4195 16.7352 19.5353 17.1957 19.49C17.6562 19.4447 18.0868 19.2416 18.414 18.9145Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArtistIcon;
